import { useState, useEffect, useCallback } from 'react';
import type { Command } from '../types';
import { CommandPaletteStorage } from '../utils/storage';

export function useRecents() {
  const [recentCommands, setRecentCommands] = useState<Command[]>([]);

  // Load recent commands from storage
  useEffect(() => {
    const ids = CommandPaletteStorage.getRecentCommands();
    // Note: We can't resolve command objects without a registry
    // The parent hook will need to provide the full commands list to filter from
    setRecentCommands([]);
  }, []);

  const addRecent = useCallback((command: Command) => {
    CommandPaletteStorage.addRecentCommand(command.id);
    CommandPaletteStorage.incrementCommandUsage(command.id);

    // Update local state with the actual command object
    setRecentCommands(prev => {
      const filtered = prev.filter(cmd => cmd.id !== command.id);
      return [command, ...filtered].slice(0, 10);
    });
  }, []);

  const clearRecents = useCallback(() => {
    CommandPaletteStorage.clearStorage();
    setRecentCommands([]);
  }, []);

  return {
    recentCommands,
    addRecent,
    clearRecents,
  };
}